import React, { Component } from "react";
import InformationIcon from "../../../assets/Information_Icon.svg";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import {
  dashboardSummaryData,
  dashboardSummaryReportDownload
} from "../../../services/apiServices";
import request from "../../../services/requestService";
import { LoaderPage } from "../../../component/Loader";
import NoDataFound from "../../../component/NoDataFound";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
class DashboardSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      error: null,
      reportIds: [],
      excelIcon: true,
      downloadIcon: false,
      allReportIds: [],
      downloadIds: [],
      allLink: [],
      allUrl: [],
      allFileName: []
    };
  }

  async componentDidMount() {
    try {
      const response = await request(dashboardSummaryData());
      const result = response.data;
      const ids = [];
      result.forEach(monthData => {
        monthData.reports.forEach(report => {
          ids.push(report.id);
        });
      });
      this.setState({
        data: result,
        loading: false,
        allReportIds: ids
      });
    } catch (error) {
      this.setState({
        error: error,
        loading: false
      });
      console.error("Error fetching dashboard summary data:", error);
    }
  }
  formatDateShort(dateString) {
    const months = {
      January: "Jan",
      February: "Feb",
      March: "Mar",
      April: "Apr",
      May: "May",
      June: "June",
      July: "July",
      August: "Aug",
      September: "Sep",
      October: "Oct",
      November: "Nov",
      December: "Dec"
    };

    const parts = dateString.split(" ");
    if (parts.length !== 3) {
      return "Invalid Date Format";
    }

    const day = parts[0];
    const month = parts[1];
    const year = parts[2];

    const formattedMonth = months[month];

    if (formattedMonth) {
      return `${day} ${formattedMonth} ${year}`;
    } else {
      return "Invalid Month";
    }
  }
  downloadStart = id => {
    this.setState({
      reportIds: this.state.reportIds.concat(id),
      allReportIds: this.state.allReportIds.filter(val => val !== id)
    });
    setTimeout(async () => {
      this.setState({
        downloadIcon: true,
        excelIcon: false
      });
      try {
        this.downloadAPI(id);
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }, 200);
  };
  downloadAPI = async id => {
    const response = await request(dashboardSummaryReportDownload(id));
    const base64String = response.data.base64Data;
    const fileName = response.data.fileName;
    const fileType = response.data.fileType;
    const base64WithoutPrefix = base64String.includes(",")
      ? base64String.split(",")[1]
      : base64String;

    const byteCharacters = atob(base64WithoutPrefix);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    const newUrl = { id: id, url: url };
    const newLink = { id: id, link: link };
    const newFilename = { id: id, fileName: fileName };
    this.setState(prevState => ({
      allUrl: [...prevState.allUrl, newUrl],
      allLink: [...prevState.allLink, newLink],
      allFileName: [...prevState.allFileName, newFilename],
      downloadIds: this.state.downloadIds.concat(id),
      reportIds: this.state.reportIds.filter(val => val !== id)
    }));
  };

  downloadReport = id => {
    const {
      allUrl,
      allLink,
      allFileName,
      allReportIds,
      downloadIds
    } = this.state;
    const foundUrl = allUrl.find(item => item.id === id);
    const foundLink = allLink.find(item => item.id === id);
    const foundFilename = allFileName.find(item => item.id === id);
    if (foundUrl && foundLink && foundFilename) {
      const link = foundLink.link;
      const url = foundUrl.url;
      const fileName = foundFilename.fileName;
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.setState({
        allUrl: allUrl.filter(val => val.id !== id),
        allLink: allLink.filter(val => val.id !== id),
        allFileName: allFileName.filter(val => val.id !== id),
        allReportIds: allReportIds.concat(id),
        downloadIds: downloadIds.filter(val => val !== id)
      });
    } else {
      console.log(`Object with ID ${id} not found.`);
    }
  };
  render() {
    const {
      data,
      loading,
      reportIds,
      downloadIcon,
      allReportIds,
      downloadIds
    } = this.state;

    return (
      <React.Fragment>
        <LoaderPage loading={loading} />
        <div className="documents_container">
          <div className="header-wrapper">
            <h3 className="header">
              Dashboard Summary
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="top"
                overlay={
                  <Tooltip className="dashboard-summary-infoicon-tolltip">
                    New Dashboard summary added every Saturday
                  </Tooltip>
                }
              >
                <Image
                  src={InformationIcon}
                  className="dashboard-summary-infoicon"
                />
              </OverlayTrigger>
            </h3>
          </div>
          <div className="dashboard-summary-report-body">
            {data.length == 0 ? (
              <NoDataFound />
            ) : (
              <>
                {data.map(monthData => (
                  <div key={monthData.month} className="month-section mb-4">
                    <h4 className="month-header">{monthData.month}</h4>
                    <div className="reports-container d-flex flex-wrap gap-3">
                      {" "}
                      {/* Flexbox for single line */}
                      {monthData.reports && monthData.reports.length > 0
                        ? monthData.reports.map((report, reportIndex) => (
                            <div
                              key={report.id}
                              className="report-box d-flex flex-column align-items-center justify-content-between text-center"
                              style={{
                                marginLeft: reportIndex > 0 ? "15px" : "0",
                                cursor: reportIds.includes(report.id)
                                  ? null
                                  : "pointer"
                              }}
                              onClick={() =>
                                downloadIcon && downloadIds.includes(report.id)
                                  ? this.downloadReport(report.id)
                                  : this.downloadStart(report.id)
                              }
                            >
                              <div class="report-only-download-box visible">
                                <span
                                  class="download-excel-component  "
                                  style={{ border: "1.4px solid #acacac" }}
                                >
                                  {allReportIds.includes(report.id) ? (
                                    <span class="download-mis-file download-icon ">
                                      <span class="download-icons-excel-ministry" />
                                    </span>
                                  ) : null}
                                  {reportIds.includes(report.id) ? (
                                    <>
                                      <span className="download-icon downloading">
                                        <span class="dashboard-summary-excel-icon" />
                                        <span className="download-icons-excel-state" />
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          className="dashboar-summary-spinner"
                                        />
                                      </span>
                                    </>
                                  ) : null}
                                  {downloadIcon &&
                                  downloadIds.includes(report.id) ? (
                                    <span className="download-icon agenda-download-ppt-icon">
                                      <a
                                        className="download-img"
                                        download={"Abcde.xls"}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faDownload}
                                          size="2x"
                                        />
                                      </a>
                                    </span>
                                  ) : null}
                                </span>
                              </div>
                              <span
                                className="report-upload-date"
                                style={{
                                  opacity: reportIds.includes(report.id)
                                    ? "0.4"
                                    : null
                                }}
                              >
                                {this.formatDateShort(report.uploadDate)}
                              </span>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DashboardSummary;
